
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const EventErrorState = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-black flex flex-col">
      <SEO />
      <Header />
      <main className="flex-grow container mx-auto px-4 pt-24">
        <div className="flex flex-col items-center justify-center h-full text-white">
          <h1 className="text-2xl font-bold mb-4">Event Not Found</h1>
          <p className="mb-8">The event you're looking for could not be found.</p>
          <Button 
            onClick={() => navigate("/")}
            variant="outline"
          >
            Return to Home
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};
